/**
 * Map of stream providers -> broker id
 */
export const STREAM_PROVIDERS = /** @type {const} */ ({
  Betradar: 1,
  Statsperform: 2,
  IMGArena: 3,
  SIS: 4,
  Oddin: 7,
  RMG: 8,
});

/**
 * Map of stream types -> type id
 */
export const STREAM_TYPES = /** @type {const} */ ({
  DASH_MANIFEST: 1,
  CMAF_MANIFEST: 2,
  HLS: 3,
  HLS_MANIFEST: 4,
});

/**
 * @typedef {STREAM_PROVIDERS[keyof STREAM_PROVIDERS]} TSTREAM_PROVIDERS_VALUES  
 */